"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderTeachingPopover_unstable", {
    enumerable: true,
    get: function() {
        return renderTeachingPopover_unstable;
    }
});
const _reactpopover = require("@fluentui/react-popover");
const renderTeachingPopover_unstable = _reactpopover.renderPopover_unstable;
